export const DEFAULT_DOCUMENT = 'default';
export const DEFAULT_INDEX = 1;